import { defineMessages } from '@edx/frontend-platform/i18n';
import { stepNames } from 'constants/index';

const messages = defineMessages({
  promptHeader: {
    defaultMessage: 'Prompt',
    description: 'prompt header',
    id: 'frontend-app-ora.xblock-studio-view.promptHeader',
  },
  [stepNames.studentTraining]: {
    defaultMessage: 'Practice grading',
    description: 'studentTraining label',
    id: 'frontend-app-ora.xblock-studio-view.studentTrainingLabel',
  },
  [stepNames.self]: {
    defaultMessage: 'Self assessment',
    description: 'self label',
    id: 'frontend-app-ora.xblock-studio-view.selfLabel',
  },
  [stepNames.peer]: {
    defaultMessage: 'Peer assessment',
    description: 'peer label',
    id: 'frontend-app-ora.xblock-studio-view.peerLabel',
  },
  [stepNames.staff]: {
    defaultMessage: 'Staff assessment',
    description: 'staff label',
    id: 'frontend-app-ora.xblock-studio-view.staffLabel',
  },
  collapseAllButton: {
    defaultMessage: 'Collapse all',
    description: 'collapse all button',
    id: 'frontend-app-ora.xblock-studio-view.collapseAllButton',
  },
  expandAllButton: {
    defaultMessage: 'Expand all',
    description: 'expand all button',
    id: 'frontend-app-ora.xblock-studio-view.expandAllButton',
  },
  scheduleHeader: {
    defaultMessage: 'Schedule',
    description: 'schedule header',
    id: 'frontend-app-ora.xblock-studio-view.schedule.scheduleHeader',
  },
  responseLabel: {
    defaultMessage: 'Response',
    description: 'response label',
    id: 'frontend-app-ora.xblock-studio-view.schedule.responseLabel',
  },
  startLabel: {
    defaultMessage: 'start: ',
    description: 'start label',
    id: 'frontend-app-ora.xblock-studio-view.schedule.startLabel',
  },
  dueLabel: {
    defaultMessage: 'due: ',
    description: 'due label',
    id: 'frontend-app-ora.xblock-studio-view.schedule.dueLabel',
  },
  notSetLabel: {
    defaultMessage: 'Not set',
    description: 'not set label',
    id: 'frontend-app-ora.xblock-studio-view.schedule.notSetLabel',
  },
  assessmentStepsHeader: {
    defaultMessage: 'Assessment steps',
    description: 'assessment steps header',
    id: 'frontend-app-ora.xblock-studio-view.assessmentStepsHeader',
  },
  stepLabel: {
    defaultMessage: 'Step',
    description: 'step label',
    id: 'frontend-app-ora.xblock-studio-view.stepLabel',
  },
  settingsHeader: {
    defaultMessage: 'Settings',
    description: 'settings header',
    id: 'frontend-app-ora.xblock-studio-view.settingsHeader',
  },
  textResponseLabel: {
    defaultMessage: 'Text response: ',
    description: 'text response label',
    id: 'frontend-app-ora.xblock-studio-view.textResponseLabel',
  },
  responseEditorLabel: {
    defaultMessage: 'Response editor: ',
    description: 'response editor label',
    id: 'frontend-app-ora.xblock-studio-view.responseEditorLabel',
  },
  fileUploadLabel: {
    defaultMessage: 'File uploads: ',
    description: 'file upload label',
    id: 'frontend-app-ora.xblock-studio-view.fileUploadLabel',
  },
  fileUploadLimitLabel: {
    defaultMessage: 'File upload limit: ',
    description: 'file upload limit label',
    id: 'frontend-app-ora.xblock-studio-view.fileUploadLimitLabel',
  },
  allowLaTexResponsesLabel: {
    defaultMessage: 'Allow LaTeX responses: ',
    description: 'allow LaTeX responses label',
    id: 'frontend-app-ora.xblock-studio-view.allowLaTexResponsesLabel',
  },
  topResponsesLabel: {
    defaultMessage: 'Top responses: ',
    description: 'top responses label',
    id: 'frontend-app-ora.xblock-studio-view.topResponsesLabel',
  },
  teamsEnabledLabel: {
    defaultMessage: 'Teams enabled: ',
    description: 'teams enabled label',
    id: 'frontend-app-ora.xblock-studio-view.teamsEnabledLabel',
  },
  showRubricDuringResponseLabel: {
    defaultMessage: 'Show rubric during response: ',
    description: 'show rubric during response label',
    id: 'frontend-app-ora.xblock-studio-view.showRubricDuringResponseLabel',
  },
  requiredLabel: {
    defaultMessage: 'Required',
    description: 'required label',
    id: 'frontend-app-ora.xblock-studio-view.requiredLabel',
  },
  optionalLabel: {
    defaultMessage: 'Optional',
    description: 'optional label',
    id: 'frontend-app-ora.xblock-studio-view.optionalLabel',
  },
  noneLabel: {
    defaultMessage: 'None',
    description: 'none label',
    id: 'frontend-app-ora.xblock-studio-view.noneLabel',
  },
  textEditorLabel: {
    defaultMessage: 'Text editor',
    description: 'text label',
    id: 'frontend-app-ora.xblock-studio-view.textLabel',
  },
  wysiwygEditorLabel: {
    defaultMessage: 'WYSIWYG editor',
    description: 'wysiwyg label',
    id: 'frontend-app-ora.xblock-studio-view.wysiwygLabel',
  },
  falseLabel: {
    defaultMessage: 'False',
    description: 'false label',
    id: 'frontend-app-ora.xblock-studio-view.falseLabel',
  },
  trueLabel: {
    defaultMessage: 'True',
    description: 'true label',
    id: 'frontend-app-ora.xblock-studio-view.trueLabel',
  },
  rubricHeader: {
    defaultMessage: 'Rubric',
    description: 'rubric header',
    id: 'frontend-app-ora.xblock-studio-view.rubricHeader',
  },
  criteriaNameLabel: {
    defaultMessage: 'Criteria name: ',
    description: 'criteria name label',
    id: 'frontend-app-ora.xblock-studio-view.criteriaNameLabel',
  },
  criteriaDescriptionLabel: {
    defaultMessage: 'Criteria description: ',
    description: 'criteria description label',
    id: 'frontend-app-ora.xblock-studio-view.criteriaDescriptionLabel',
  },
  criteriaOptionsLabel: {
    defaultMessage: 'Criteria options: ',
    description: 'criteria options label',
    id: 'frontend-app-ora.xblock-studio-view.criteriaOptionsLabel',
  },
  pointsLabel: {
    defaultMessage: 'points',
    description: 'points label',
    id: 'frontend-app-ora.xblock-studio-view.pointsLabel',
  },
});

export default messages;
